import {makeFetchTransport, makeXHRTransport} from '@sentry/browser';
import {getRateLimitUntil, rateLimitState} from './RateLimitState';
import {reportToConsole} from './consoleReporter';

const makeBaseTransport = typeof window.fetch === 'function' ? makeFetchTransport : makeXHRTransport;

function recordRateLimit ( response ) {
    if ( response ) {
        const status = response.statusCode;
        const now = Date.now();
        const until = getRateLimitUntil( response.headers, status, now );

        if ( until ) {
            rateLimitState.suppressUntil( until );
            reportToConsole( 'suppressed', {
                retryAt: new Date( until ).toISOString(),
                status
            }, {detail: 'rate-limited'} );
        }
    }
}

export default function SentryTransport ( options ) {
    const transport = makeBaseTransport( options );

    return {
        ...transport,
        send: envelope => transport.send( envelope ).then( response => {
            recordRateLimit( response );
            return response;
        } )
    };
}
